/**
 * Public entry point for the client audio system. This is the only module
 * main.ts / session.ts should import from.
 */

import type { GameState, PlayerIdx } from '../../sim';
import { onTick as diffAndTrigger, resetEventTracking } from './events';
import { setScreen as setMusicScreen, type Screen } from './music';
import { initAudioUi } from './ui';

export type { Screen } from './music';

/** Call once at boot, before any screen transitions. Safe to call more than
 * once. Sets up the (lazy, gesture-gated) AudioContext, the speaker button,
 * and the document-level tap/invalid-click SFX listener. */
export function initAudio(): void {
  initAudioUi();
}

/** Drive the music state machine from the session lifecycle: 'menu' for the
 * main menu/lobby, 'game' once a match is running, 'none' to silence both
 * loops (not currently used, but available for e.g. a paused/background
 * tab policy later). */
export function setScreen(screen: Screen): void {
  if (screen === 'game') resetEventTracking();
  setMusicScreen(screen);
}

/** Single per-tick hook from GameSession.handlePostTick: forwards this
 * tick's GameEvents to stingers/one-shot SFX, feeds the tension-layer
 * crossfade the local player's budget, and diffs entities for the SFX that
 * have no dedicated GameEvent (train/build complete, serve income, unit
 * death, building destroyed). */
export function onTick(state: GameState, myPlayer: PlayerIdx): void {
  diffAndTrigger(state, myPlayer);
}
